/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-16 18:31:26
 * @modify date 2021-08-16 18:31:26
 * @desc 系统初始化登陆 用户信息信息编辑注册不要在这里写
 */
import { AuthEncryption } from '@mamba-le/auth';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import queryString from 'query-string';
import { forkJoin, lastValueFrom, Subject } from 'rxjs';
import { EnumAPI } from '../../apis/index';
import { EnumUserType } from '../../enums';
import AppEnv from '../../env';
import { AjaxBasics, Log } from '../../helpers';
import { ApplyController } from './apply';
import { onCreateFactoryAuth } from './auth';
import { MenuController } from './menu';
import { onCreateFactoryUser } from './userModel';

@BindAll()
export class SystemController {
  /**
   * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
   * 除非是地址栏解析或者其他方式等等
   * @memberof SystemController
   */
  readonly Auth = onCreateFactoryAuth();
  /**
   * 首页顶部菜单管理
   * @memberof SystemController
   */
  readonly Apply = new ApplyController();
  /**
   * 个人中心菜单管理
   * @memberof SystemController
   */
  readonly Menu = new MenuController();
  /**
   * 用户信息
   * @memberof SystemController
   */
  readonly User = onCreateFactoryUser();

  /**
   * 用户异步数据加载订阅
   * @type {Promise<any>}
   * @memberof ControllerUser
   */
  readonly UserSubject = new Subject();
  /**
   * token
   * @readonly
   * @memberof SystemController
   */
  get AccessToken() {
    return this.Auth.AccessToken;
  }
  /**
   * 登陆状态
   * @readonly
   * @memberof SystemController
   */
  @computed
  get LoggedIn() {
    // if (this.User.loading) {
    //   return false;
    // }
    return !lodash.isEmpty(this.AccessToken);
  }
  /**
   * 登陆
   * @param {*} formData
   * @return {*}
   * @memberof SystemController
   */
  async onLogin(body: {
    loginType?;
    password?;
    userName?;
    validationCode?;
    imgSession?;
  }) {
    try {
      // this.User.toggleLoading(true);
      const res = await AjaxBasics.request<{
        token: string;
        expire: number;
      }>(
        lodash.merge({}, EnumAPI.bffsvr_login, {
          body,
          headers: lodash.pick(body, 'imgSession'),
        }),
      );
      this.User.merge(res);
      // await this.onGetUserInfo()
      return true;
    } catch (error) {
      // this.User.toggleLoading(false);
      throw error;
    }
  }
  /**
   * 解析地址栏携带的登陆信息
   * @memberof SystemController
   */
  onParseQueryToken(query) {
    if (lodash.hasIn(query, 'token')) {
      const token = lodash.get(query, 'token');
      token && this.Auth.onSaveAccessToken(token);
    } else if (lodash.hasIn(query, 'share')) {
      const [token] = lodash.split(
        lodash.get(query, 'share'),
        AppEnv.shareSeparate,
      );
      token && this.Auth.onSaveAccessToken(token);
      // 小程序传递回来的授权 URL
    } else if (lodash.hasIn(query, 'signedUrl')) {
      const signedUrl = lodash.get(query, 'signedUrl');
      const token = AuthEncryption.AES_Decrypt(signedUrl);
      token && this.Auth.onSaveAccessToken(token);
    }
  }
  /**
   * 校验登陆状态
   * @memberof SystemController
   */
  onVerify(infoType = false) {
    return this.onGetUserInfo();
  }
  /**
   * 获取用户信息数据
   * @returns
   */
  async onGetUserInfoResponse() {
    try {
      await this.Auth.HydrateAsync;
      if (
        lodash.isEmpty(this.AccessToken) ||
        this.User.eqAccessToken(this.AccessToken)
      ) {
        this.UserSubject.complete();
        return this.User.value;
      }
      const response = await AjaxBasics.forkJoinCatchError([
        AjaxBasics.request(EnumAPI.company_auth_token),
        AjaxBasics.request(EnumAPI.partner_partnerIdentity_findInfo_new),
        AjaxBasics.request(EnumAPI.accountsvr_get_userinfo),
        AjaxBasics.request(EnumAPI.accountsvr_identity_ischoose),
        AjaxBasics.request(EnumAPI.partner_get_partnerIdentity_new),
      ]);
      let UserInfo = lodash.merge(
        {
          AccessToken: this.AccessToken,
        },
        // 企业信息
        lodash.get(response, '[0]', {}),
        // 组织信息
        lodash.get(response, '[1]', {}),
        // 用户信息
        lodash.get(response, '[2]', {}),
        {
          optionIdentity: lodash.get(response, '[3]', false),
          indentityList: lodash.get(response, '[4]', []),
        },
      );
      UserInfo = await this.onGetUserBuType(UserInfo);
      this.UserSubject.complete();
      return UserInfo;
    } catch (error) {
      this.UserSubject.complete();
      Log.error(error);
      throw error;
    }
  }
  /**
   * 获取用户信息
   * @returns
   */
  async onGetUserInfo() {
    try {
      const UserInfo = await this.onGetUserInfoResponse();
      this.User.set(UserInfo);
      const cityCode = lodash.get(
        lodash.get(UserInfo, 'currentIdentityVOList', []),
        '[0].identityDomicileVO.cityCode',
      );
      // const cityCode = lodash.get(UserInfo, 'userExtendDTO.cityCode');
      this.getCitySales(cityCode);
      // this.User.toggleLoading(false);
      return UserInfo;
    } catch (error) {
      await this.onLoginOut();
      // this.User.toggleLoading(false);
    }
  }

  async onGetUserBuType(UserInfo) {
    // if (typeof window !== 'undefined') {
    const userId = lodash.get(UserInfo, 'userId');
    if (!UserInfo.businessType && userId) {
      let businessType;
      const userType = lodash.get(UserInfo, 'userType');
      //如果是意向伙伴
      if (lodash.eq(userType, EnumUserType.Intention)) {
        businessType = await this.getIntentionBusinessType(UserInfo);
        // 分享参数 businessType 初始BU005，意向伙伴更新businessType参数
        this.Auth.onSaveDrainage({
          ...this.Auth.Drainage,
          businessType,
        });
      }
      //如果是sales
      if (lodash.eq(userType, EnumUserType.Sales)) {
        businessType = await this.getSalesBusinessType(UserInfo);
      }
      if (businessType) {
        UserInfo = lodash.merge(UserInfo, { businessType });
      }
    }
    return UserInfo;
    // }
  }

  //渠道意向伙伴获取BU
  async getIntentionBusinessType(UserInfo) {
    try {
      const res: any = await AjaxBasics.request({
        ...EnumAPI.bffsvr_get_partner_by_userid,
        body: { userId: lodash.get(UserInfo, 'userId') },
      });
      const current = lodash.find(res, ['labelType', 'IntentionBu']);
      return lodash.get(current, 'labelValue');
    } catch (error) {
      console.error('LENG ~ error', error);
    }
  }
  //sales获取BU
  async getSalesBusinessType(UserInfo) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.partner_getSales_userinfo,
        body: { userId: lodash.get(UserInfo, 'userId') },
      });
      return lodash.get(res, 'buList[0]');
    } catch (error) {
      console.error('LENG ~ error', error);
    }
  }

  /**
   * 根据用户信息获取sales的相关信息
   * @returns
   */
  async getCitySales(cityCode) {
    if (!cityCode) return;
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_salesInfo,
        body: { salesCityCode: cityCode },
      });
      this.User.merge({ salesInfo: lodash.get(res, [0]) });
    } catch (error) {}
  }
  /**
   * 获取埋点信息
   * @returns
   */
  getDots() {
    return AjaxBasics.request<string>(EnumAPI.bffsvr_user_buriedPointCollect);
  }
  /**
   * 退出登录
   * @return {*}
   * @memberof SystemController
   */
  async onLoginOut() {
    try {
      await this.Auth.HydrateAsync;
      await this.loginOut(this.AccessToken);
      await lastValueFrom(forkJoin([this.Auth.onClear(), this.User.set({})]));
    } catch (error) {}
  }
  /**
   * 清除本地信息
   * @return {*}
   * @memberof SystemController
   */
  async onClear() {
    try {
      await this.Auth.HydrateAsync;
      await lastValueFrom(forkJoin([this.Auth.onClear(), this.User.set({})]));
    } catch (error) {}
  }
  /**
   * 检查用户是否登陆
   * @return {*}
   * @memberof SystemController
   */
  onInspectUser() {
    if (this.LoggedIn) {
      return this.User.value;
    }
    throw '未登录';
  }

  /**
   * 退出登录接口调用
   * @return {*}
   * @memberof SystemController
   */
  async loginOut(AccessToken) {
    try {
      if (AccessToken) {
        await AjaxBasics.request(EnumAPI.accountsvr_loginout);
      }
    } catch (error) {
      console.log('退出登录接口error:', error);
    }
  }

  /**
   * 生成lid登出地址
   */
  createLidLoginoutUrl(isPc) {
    const ctx = isPc ? 'cGM=' : 'bW9iaWxl'; //base64串
    const url = queryString.stringifyUrl({
      url: `${AppEnv.lidDomain}/gateway`,
      query: {
        'lenovoid.action': 'uilogout',
        'lenovoid.realm': 'bp.lenovo.com',
        'lenovoid.cb': isPc
          ? window.location.origin
          : `${window.location.origin}/mobile`,
        'lenovoid.ctx': ctx,
        'lenovoid.hidelanguage': '0',
        'lenovoid.hideloginreg': '0',
        'lenovoid.hidemaillogin': '0',
        'lenovoid.hideqq': '0',
        'lenovoid.hideqrlogin': '0',
        'lenovoid.hideregemail': '0',
        'lenovoid.hidesina': '0',
        'lenovoid.hidewechat': '0',
      },
    });
    return url;
  }

  /**
   * 处理保存app注入的数据
   */
  onSaveAppInfo(appInfo) {
    const { token } = appInfo;
    token && this.Auth.onSaveAccessToken(token);
  }
}
